/* eslint-disable react/jsx-curly-brace-presence */
import { lazy } from 'react'
import ConsentTemplateLibrary from 'screens/AccountsSettings/ConsentTemplates'
import { InitialAssessmentEditFormWrapper } from 'components/forms/screens/InitialAssessmentEditFormWrapper'
import { ProAdvert } from 'components/generic'
import { Route } from 'react-router-dom'
import AccountsSettingsScreen from 'screens/AccountsSettings/AccountSettingsView'
import ConsentTemplateView from 'screens/AccountsSettings/ConsentTemplates/ConsentTemplateView'
import { FamilySettingsScreen } from 'screens/AccountsSettings/FamilySettings'
import FamilyInviteScreen from 'screens/AccountsSettings/FamilySettings/FamilyInviteScreen'
import { HomeSettingsScreen } from 'screens/AccountsSettings/HomeSettings'
import MonitoringReportSettingsScreen from 'screens/AccountsSettings/MonitoringReportSettings/MonitoringReportSettingsScreen'
import MemberBenefits from 'screens/AccountsSettings/MemberBenefits'
import SkillNeedTemplateScreen from 'screens/AccountsSettings/SkillsAndNeeds/SkillNeedTemplateScreen'
import { ZonesScreen } from 'screens/AccountsSettings/Zones'
import {
  CarePlanHistoryScreen,
  CarePlanViewScreenWrapper,
  CarePlanReviewScreen,
  CarePlansListScreen,
} from 'screens/CarePlans/screens'
import { ResidentMedicationsDashboardScreen } from 'screens/Residents/screens'
import { ResidentScreenFeatureFlagWrapper } from 'screens/Residents/ResidentScreenFeatureFlagWrapper'
import { RedirectHandler } from 'screens/Residents/components'
import {
  ResidentAboutMeScreen,
  ResidentAboutMeScreenHistory,
} from 'screens/Residents/screens/ResidentAboutMeScreen'
import { ResidentChartsDashboardScreen } from 'screens/Residents/screens/ResidentChartsDashboardScreen'
import {
  ConsentFormScreen,
  ResidentConsentFormsScreen,
} from 'screens/Residents/screens/ResidentConsentScreens'
import { ResidentDocumentsScreen } from 'screens/Residents/screens/ResidentDocumentsScreen'
import { ResidentEditScreen } from 'screens/Residents/screens/ResidentEditScreen'
import {
  EMARMedicationStockScreen,
  EMARResidentScreen,
  EMARResidentStockScreen,
  ResidentMedScreen,
} from 'screens/Residents/screens/ResidentEmarScreens'
import { EMARPaywall } from 'screens/Residents/screens/ResidentEmarScreens/components'
import {
  ResidentMedDetailsScreen,
  ResidentMedEditScreen,
} from 'screens/Residents/screens/ResidentEmarScreens/ResidentMedScreen'
import {
  ResidentInitialAssessmentCompleteScreen,
  ResidentInitialAssessmentDashboardScreen,
} from 'screens/Residents/screens/ResidentInitialAssessmentScreens'
import { ResidentMedChartScreen } from 'screens/Residents/screens/ResidentMedChartScreen'
import { ResidentNeedsScreen } from 'screens/Residents/screens/ResidentNeedsScreen'
import {
  ResidentRiskAssessmentDashboardScreen,
  ResidentRiskAssessmentScreen,
} from 'screens/Residents/screens/ResidentRiskAssessmentsScreens'
import BillingScreen from 'screens/AccountsSettings/Billing'

import { ID } from '../utils'
import ResidentList from 'screens/Residents/screens/ResidentsList/ResidentsList'
import { goalsRoutes } from './goals'
import RiskAssessmentDashboard from 'screens/Reports/RiskAssessmentDashboard/RiskAssessmentDashboard'
import {
  GroupBMIReports,
  GroupCarePlans,
  GroupToDosStatus,
} from 'screens/Groups/GroupReports'
import LazyLoad from '../LazyLoad'
import { ResidentPersonalInformation } from 'screens/Residents/screens/ResidentProfileScreen/screens'
import ResidentCareInformation from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentCareInformation/ResidentCareInformation'
import { ResidentImportantPeopleScreen } from 'screens/Residents/screens/ResidentImportantPeopleScreens/ResidentimportantPeopleScreen'
import { importantPeopleRoutes } from './importantPeople'
import { contingencyPlansRoutes } from './contingencyPlans'
import { SharedCareRecordScreen } from 'screens/Residents/screens/ResidentProfileScreen/screens/SharedCareRecordScreen'
import ResidentContactDetails from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentContactDetails/ResidentContactDetails'
import ResidentSiteInformation from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentSiteInformation/ResidentSiteInformation'
import { GPConnectRoutes } from './GPConnect'
import IncidentReportSettingsScreen from 'screens/AccountsSettings/IncidentReportsSettings/IncidentReportsSettingsScreen'

import {
  CarePackageAndPatternsScreen,
  EditCarePackageAndPatternsScreen,
} from 'screens/Rostering/screens'
import CarePackageSettingsScreen from 'screens/Rostering/siteSettings/CarePackageSettings'
import ContractsAndAbsenceSettingsScreen from 'screens/Rostering/siteSettings/ContractsAndAbsenceSettings'
import { ResidentProfileScreen } from 'screens/Residents/screens/ResidentProfileScreen/ResidentProfileScreen'
import WarningsSettingsScreen from 'screens/Rostering/siteSettings/WarningsSettings'

const ResidentDailyLogsScreen = lazy(
  () => import('screens/Residents/screens/ResidentDailyLogsScreen')
)
const BodyMapsHistoryScreen = lazy(
  () => import('screens/Residents/components/BodyMaps/BodyMapsHistoryScreen')
)
const BodyMapsReportScreen = lazy(
  () => import('screens/Residents/components/BodyMaps/BodyMapsReportScreen')
)
const BodyMapsScreen = lazy(
  () => import('screens/Residents/components/BodyMaps/BodyMapsScreen')
)
const ResidentChartScreen = lazy(
  () =>
    import('screens/Residents/screens/ResidentChartScreen/ResidentChartScreen')
)

const RESIDENTS_PATH = 'residents'
const CHART = 'chart'
const PDF = 'pdf'
const MEDICATION = `${RESIDENTS_PATH}/${ID}/${PDF}/emar/:medication_id`
const PROFILE = `profile`
const GOALS_URL = `goals`
const GOALS_TEASER_URL = 'goals-coming-soon'
const LIST = `list`

export const RESIDENTS = {
  INDEX: RESIDENTS_PATH,
  EMAR: `${RESIDENTS_PATH}/${ID}/pdf/emar`,
  CONSENT_FORM: `${RESIDENTS_PATH}/${ID}/${PDF}/consent/:consent_form_id`,
  ABOUT_ME: `${RESIDENTS_PATH}/${ID}/${PDF}/about-me`,
  MEDICATION,
  MEDICATION_CHART: `${MEDICATION}/${CHART}`,
  STOCK: `${MEDICATION}/stock`,
  LIST: `${RESIDENTS_PATH}/${LIST}`,
  PROFILE: `${RESIDENTS_PATH}/${ID}/${PROFILE}`,
  GOALS: `${RESIDENTS_PATH}/${ID}/${GOALS_URL}`,
  GOALS_TEASER: `${RESIDENTS_PATH}/${ID}/${GOALS_TEASER_URL}`,
}

/* const LoadFederatedComponent = ({
  remoteName,
  exposedModule,
}: {
  remoteName: 'rostering'
  exposedModule: string
}) => {
  const LazyComponent = window.loadComponent(remoteName, exposedModule)

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyComponent />
    </Suspense>
  )
} */

export const residentsRoutes = (
  <>
    <Route path={RESIDENTS.LIST} element={<ResidentList />} />,
    <Route path={RESIDENTS.EMAR} element={<EMARResidentScreen />} />,
    <Route
      path={RESIDENTS.CONSENT_FORM}
      element={<ConsentFormScreen printPDF />}
    />
    <Route
      path={RESIDENTS.ABOUT_ME}
      element={<ResidentAboutMeScreen printPDF />}
    />
    <Route path={RESIDENTS.MEDICATION} element={<ResidentMedScreen />}>
      <Route path={CHART} element={<ResidentMedChartScreen />} />
    </Route>
    <Route path={RESIDENTS.STOCK} element={<EMARMedicationStockScreen />} />
    <Route
      path={RESIDENTS.INDEX}
      element={<ResidentScreenFeatureFlagWrapper />}
    >
      {GPConnectRoutes}
      <Route index element={<RedirectHandler />} />
      {goalsRoutes}
      <Route path={`${ID}/${PROFILE}`} element={<ResidentProfileScreen />} />
      <Route
        path=":id/personal-information"
        element={<ResidentPersonalInformation />}
      />
      <Route
        path=":id/care-related-information"
        element={<ResidentCareInformation />}
      />
      <Route
        path=":id/site-related-information"
        element={<ResidentSiteInformation />}
      />
      <Route path=":id/contact-details" element={<ResidentContactDetails />} />
      {contingencyPlansRoutes}
      <Route
        path=":id/important-people"
        element={<ResidentImportantPeopleScreen />}
      />
      {importantPeopleRoutes}
      <Route path=":id/about-me" element={<ResidentAboutMeScreen />} />
      <Route
        path=":id/about-me/history"
        element={<ResidentAboutMeScreenHistory />}
      />
      <Route path=":id/profile/edit" element={<ResidentEditScreen />} />
      <Route
        path=":id/profile/medications"
        element={<ResidentMedicationsDashboardScreen />}
      />
      <Route
        path=":id/care-package-and-patterns"
        element={<CarePackageAndPatternsScreen />}
      />
      <Route
        path=":id/care-package-and-patterns/edit"
        element={<EditCarePackageAndPatternsScreen />}
      />
      <Route
        path=":id/daily-report"
        element={
          <LazyLoad>
            <ResidentDailyLogsScreen />
          </LazyLoad>
        }
      />
      <Route
        path=":id/charts"
        element={
          <LazyLoad>
            <ResidentChartsDashboardScreen />
          </LazyLoad>
        }
      />
      <Route
        path=":id/charts/body_maps"
        element={
          <LazyLoad>
            <BodyMapsScreen />
          </LazyLoad>
        }
      />
      <Route
        path=":id/charts/body_maps/history"
        element={
          <LazyLoad>
            <BodyMapsHistoryScreen />
          </LazyLoad>
        }
      />
      <Route
        path=":id/charts/body_maps/:body_map_report_id"
        element={
          <LazyLoad>
            <BodyMapsReportScreen />
          </LazyLoad>
        }
      />
      <Route
        path=":id/charts/:reporting_id"
        element={
          <LazyLoad>
            <ResidentChartScreen />
          </LazyLoad>
        }
      />
      <Route path=":id/documents" element={<ResidentDocumentsScreen />} />
      <Route path=":id/care-plans" element={<CarePlansListScreen />} />
      <Route
        path=":id/care-plans/:care_plan_id"
        element={<CarePlanViewScreenWrapper />}
      />
      <Route
        path=":id/care-plans/:care_plan_id/edit"
        element={<CarePlanReviewScreen />}
      />
      <Route
        path=":id/care-plans/:care_plan_id/history"
        element={<CarePlanHistoryScreen />}
      />
      <Route
        path=":id/care-plans/:care_plan_id/history/:revision_id"
        element={<CarePlanViewScreenWrapper />}
      />
      <Route
        path=":id/initial-assessments"
        element={<ResidentInitialAssessmentDashboardScreen />}
      />
      <Route
        path=":id/initial-assessments/complete"
        element={<ResidentInitialAssessmentCompleteScreen />}
      />
      <Route
        path=":id/initial-assessments/:pre_assessment_id/edit"
        element={<InitialAssessmentEditFormWrapper />}
      />
      <Route
        path=":id/risk-assessments"
        element={<ResidentRiskAssessmentDashboardScreen />}
      />
      <Route
        path=":id/risk-assessment-scores"
        element={<RiskAssessmentDashboard type="resident" />}
      />
      <Route
        path=":id/risk-assessments/:risk_assessment_id"
        element={<ResidentRiskAssessmentScreen />}
      />
      <Route
        path=":id/risk-assessments/:risk_assessment_id/history"
        element={<ResidentRiskAssessmentDashboardScreen />}
      />
      <Route
        path=":id/risk-assessments/:risk_assessment_id/history/:risk_assessment_history_id"
        element={<ResidentRiskAssessmentScreen />}
      />
      <Route path=":id/shared-care-record" element={<SharedCareRecordScreen />} />
      <Route path=":id/emar" element={<EMARResidentScreen />} />
      <Route path=":id/emar/stock" element={<EMARResidentStockScreen />} />
      <Route path=":id/emar/:medication_id" element={<ResidentMedScreen />}>
        <Route path="chart" element={<ResidentMedChartScreen />} />
        <Route path="details" element={<ResidentMedDetailsScreen />} />
        <Route path="edit" element={<ResidentMedEditScreen />} />
      </Route>
      <Route
        path=":id/emar/:medication_id/stock"
        element={<EMARMedicationStockScreen />}
      />
      <Route path=":id/consent" element={<ResidentConsentFormsScreen />} />
      <Route
        path=":id/consent/:consent_form_id"
        element={<ConsentFormScreen />}
      />
      <Route path=":id/needs" element={<ResidentNeedsScreen />} />
      <Route
        path="group-reports/care-plans"
        element={
          <LazyLoad>
            <GroupCarePlans />
          </LazyLoad>
        }
      />
      <Route
        path="group-reports/todos"
        element={
          <LazyLoad>
            <GroupToDosStatus />
          </LazyLoad>
        }
      />
      <Route
        path="group-reports/bmi"
        element={
          <LazyLoad>
            <GroupBMIReports />
          </LazyLoad>
        }
      />
      <Route path="pro-advert" element={<ProAdvert />} />
      <Route path="emar-activation" element={<EMARPaywall />} />
      <Route path="settings" element={<AccountsSettingsScreen />}>
        <Route path="billing" element={<BillingScreen />} />
        <Route path="home-settings" element={<HomeSettingsScreen />} />
        <Route
          path="incident-reports-settings"
          element={<IncidentReportSettingsScreen />}
        />
        <Route path="care-package" element={<CarePackageSettingsScreen />} />
        <Route
          path="contracts-and-absences"
          element={<ContractsAndAbsenceSettingsScreen />}
        />
        <Route
          path="report-settings"
          element={<MonitoringReportSettingsScreen />}
        />
        <Route path="warnings" element={<WarningsSettingsScreen />} />
        <Route path="family-settings" element={<FamilySettingsScreen />} />
        <Route path="family-invite" element={<FamilyInviteScreen />} />
        <Route path="zones" element={<ZonesScreen />} />
        <Route path="perks" element={<MemberBenefits />} />
        <Route path="consent-templates" element={<ConsentTemplateLibrary />} />
        <Route path="consent-templates/:id" element={<ConsentTemplateView />} />
        <Route path="skills-and-needs" element={<SkillNeedTemplateScreen />} />
      </Route>
    </Route>
  </>
)
